<template>

<!-- TEMPORARILY HIDDEN: footer suppressed for the trial. To restore, remove
     the `v-if="false"` below (markup/styles are intentionally kept intact). -->
<footer v-if="false" class="foot">

	<!-- geekgroup lockup: the real gg mark (its colour glyph on a dark badge,
	     exactly as Tally renders it) + a "part of geekgroup" line -->
	<a class="foot-gg" href="https://geekgroup.app" target="_blank" rel="noopener" aria-label="geekgroup">
		<span class="foot-gg-icon"></span>
		<span class="foot-gg-name">geek<span>group</span></span>
	</a>

	<!-- centred legal links, mirroring Tally's footer row -->
	<nav class="foot-links">
		<a class="foot-link" href="https://geekgroup.app" target="_blank" rel="noopener">About</a>
		<a class="foot-link" href="https://geekgroup.app/privacy" target="_blank" rel="noopener">Privacy</a>
		<a class="foot-link" href="https://geekgroup.app/terms" target="_blank" rel="noopener">Terms</a>
	</nav>

	<!-- BoardGameGeek data credit: the real bgg mark -->
	<a class="foot-bgg" href="https://boardgamegeek.com" target="_blank" rel="noopener" aria-label="Powered by BoardGameGeek">
		<img :src="bggLogo" alt="Powered by BoardGameGeek" />
	</a>

</footer>

</template>

<script>

/*
	The slim site footer, on every screen. Mirrors Tally's footer treatment: the
	real geekgroup mark (its colour glyph on a dark circular badge, via CSS
	background like Tally) in a "part of geekgroup" lockup on the left, a centred
	About / Privacy / Terms link row, and the real BoardGameGeek mark on the
	right. Styled for boxart's LIGHT editorial palette: paper ground, hairline
	top divider, ink/muted text — none of Tally's dark chrome.
*/

import bggLogo from '../../assets/bgg.svg'

export default {

	data: function() {

		return {
			bggLogo: bggLogo
		}

	}

}

</script>

<style scoped>

/* three tracks: brand left, links dead-centre, BGG credit right. The 1fr side
   tracks keep the links optically centred regardless of the marks' widths. */
.foot {
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	column-gap: 24px;
	padding: 16px 28px;
	width: 100%;
	box-sizing: border-box;
	border-top: 1px solid var(--hairline);
	font-family: var(--font-mono);
	font-size: 10px;
	letter-spacing: 0.04em;
	color: var(--muted);
}

.foot-gg {
	display: flex;
	align-items: center;
	gap: 9px;
	text-decoration: none;
	color: var(--muted);
	justify-self: start;
}

/* the gg colour glyph on its own dark circular badge — exactly Tally's
   treatment (the mark is bright and needs a dark backing) */
.foot-gg-icon {
	width: 28px;
	height: 28px;
	flex: none;
	background-image: url(../../assets/gg.svg);
	background-size: auto 24px;
	background-position: calc(50% - 1px) calc(50% + 1px);
	background-repeat: no-repeat;
	background-color: rgba(0, 0, 0, 0.55);
	border-radius: 50%;
}

/* the geekgroup wordmark, set in Barlow exactly like Tally (geek + group);
   adapted for the light footer — ink "geek", geekgroup-gold "group" */
.foot-gg-name {
	font-family: 'Barlow', sans-serif;
	font-size: 14px;
	font-weight: 700;
	letter-spacing: 1.5px;
	line-height: 14px;
	color: var(--ink);
}

.foot-gg-name span {
	color: #b8860b;
}

/* the centred About / Privacy / Terms links */
.foot-links {
	display: flex;
	align-items: center;
	gap: 18px;
	justify-self: center;
}

.foot-link {
	font-family: var(--font-mono);
	font-size: 10px;
	font-weight: 600;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--muted);
	text-decoration: none;
}

.foot-link:hover {
	color: var(--ink);
}

.foot-bgg {
	display: flex;
	align-items: center;
	text-decoration: none;
	justify-self: end;
}

.foot-bgg img {
	display: block;
	width: 104px;
	height: auto;
}

@media (max-width: 599px) {

	/* stack: links centred on top, the two marks centred in a row beneath */
	.foot {
		grid-template-columns: auto auto;
		justify-content: center;
		row-gap: 18px;
		column-gap: 28px;
		padding: 16px;
	}

	.foot-links {
		grid-column: 1 / -1;
		grid-row: 1;
	}

	.foot-gg {
		grid-column: 1;
		grid-row: 2;
		justify-self: end;
	}

	.foot-bgg {
		grid-column: 2;
		grid-row: 2;
		justify-self: start;
	}

	.foot-bgg img {
		width: 92px;
	}

}

</style>
